import {
  array,
  object,
  string,
} from 'yup'

import { AccountType, CompanyDetails, Contact } from '../../../api'
import { credentials }                          from '../../../project-utils/credentials-cookie'
import { genArgConverter }                      from '../../../utils'
import { i18nErrorCodes }                       from '../form-utils'
import { cifSchema, emailSchema, phoneSchema }  from './formatSchemas'

const { required } = i18nErrorCodes

const companyShape = {
  name:        string().required(required),
  cif:         cifSchema.required(required),
  address:     string().required(required),
  phone:       phoneSchema,
  mobile:      phoneSchema.required(required),
  contactName: string().required(required),
  contacts:    array(),
}

export default object().shape({
  ...companyShape,
  email: emailSchema.required(required),
})

export const companyEditSchema = object().shape(companyShape)

export interface CreateCompanyFormValues extends CompanyDetails {
  email: string
  contacts: Contact []
}

export interface EditCompanyFormValues extends CompanyDetails {
  contacts: Contact []
}

const emptyCompanyCommon = {
  name:        '',
  cif:         '',
  address:     '',
  phone:       '',
  mobile:      '',
  contactName: '',
  contacts:    [],
}

export const emptyCreateCompany: CreateCompanyFormValues = {
  email: '',
  ...emptyCompanyCommon,
}

export const emptyEditCompany: EditCompanyFormValues = emptyCompanyCommon

const companyTypeByAdminType = {
  [ AccountType.BlcMentoring ]: AccountType.CompanyMentoring,
  [ AccountType.BlcCoaching ]:  AccountType.CompanyCoaching,
}

const companyValueConverter = ({
  email,
  contacts,
  ...rest
}: CreateCompanyFormValues) => ({
  email,
  contacts,
  details: rest,
  type:    companyTypeByAdminType[ (credentials.type as AccountType) ],
})

export const convertCreateCompany = genArgConverter(companyValueConverter)

export const convertEditCompany = genArgConverter(
  (
    id,
    companyValues
  ) => [
    id,
    companyValueConverter(companyValues),
  ]
)



// WEBPACK FOOTER //
// ./src/components/forms/schemas/company.schema.ts